import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2rh5jwjkzg: FaireBrandEntity = {
  token: "b_2rh5jwjkzg",
  type: "brand",
  name: "Agapée Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/46b437dc5d952ceb751f85325920954d763e13ed36bd8c8004ce8238f7e36620.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c5dcded93b32759166941138ad4d374ffb130c0addf8c3498a6bf5094bfbef34.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/46b437dc5d952ceb751f85325920954d763e13ed36bd8c8004ce8238f7e36620.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c5dcded93b32759166941138ad4d374ffb130c0addf8c3498a6bf5094bfbef34.jpeg",
  location: "Paris, FRA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 239,
  isTopShop: true,
  isInsider: false,
  description:
    "Agapée is a voyage, born from love (agápē in Ancient Greek) and guided by kindness, where ancient artistry meets contemporary craft. Inspired by the warmth of the Mediterranean and the quiet shimmer of its waves, our hammered golden jewelry has been designed in Paris since 2019 as an homage to traditional artisanship and archaeological findings. Necklaces, chokers, bracelets, rings and earrings: each piece tells a meaningful story that reflects the rich cultural heritage and timeless beauty of the Mediterranean.\n\nOur jewelry is 18k gold plated and free of nickel, lead and allergens. Every Agapée creation comes with a two year warranty against oxidation and plating defects.\n\nEach piece is carefully wrapped in a cotton and linen pouch and placed inside our signature box. \n\nEstimated delivery: \n- Europe 4 to 6 business days\n- Americas 4 to 8 business days\n- Oceania 7 to 15 business days\nImport duties are covered for the US and the UK.\n\nPlease read our terms and conditions here: https://bit.ly/3x4H7Wr. Agapée creations are made to be sold in physical boutiques. Online resale, including on your own website, is not permitted under our wholesale agreement. Feel free to reach out with any questions.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:45.486Z",
    importedBy: "entity-db-cli",
  },
};
